import React from 'react'

const FooterMini = () => {
    return (
        <div className='bg-[#1A76D1] py-4'>
            <div className="container">
                <div className="flex justify-between items-center">
                    <div className="text-poppins text-white text-[14px] font-[400]">
                        Copyright 2024. All rights reserved.
                    </div>
                    <div className="flex justify-between items-center">
                        <div className="text-poppins text-white text-[14px] font-[400]">
                            About Us
                        </div>
                        <div className="mx-5 text-poppins text-white text-[14px] font-[400]">
                            Our Services
                        </div>
                        <div className="text-poppins text-white text-[14px] font-[400]">
                            Blogs
                        </div>
                        <div className="mx-5 text-poppins text-white text-[14px] font-[400]">
                            Contact Us
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FooterMini